import {validateForm} from "./form-validation.js";

function generateCampaignCode () {
  const webUrls = []; // Contains all non-empty web urls from url input fields. Used to create the UTMs and UTM output fields.

  // Find all urls, check if they are empty, send non-empty urls to addUTMUrlFields()
  var urlInputFields = document.querySelectorAll('[data-url-input]');

  urlInputFields.forEach(function (urlField) {
    if(urlField.value !== null && urlField.value !== "" ) {
      webUrls.push(urlField.value);
    }
  })

  addUTMUrlFields(webUrls)

  var formData = getFormData()

  // set the value of the other input boxes
  document.getElementById("campaign-tag-email-campaignsource").value = formData.source.toLowerCase()
  document.getElementById("campaign-tag-email-campaignmedium").value = formData.medium.toLowerCase()

  var campaignCodified = getCampaignCodified(
    formData.campaignowner,
    formData.marketingunit,
    formData.marketingsubunit,
    formData.brand,
    formData.agencyrefid,
  );

  for (var i = 0; i < webUrls.length; i++){
    document.getElementById("campaign-tag-utm-"+i).value = (
      getCampaignCodeUTM(
        webUrls[i].trim(),
        formData.source,
        formData.medium,
        campaignCodified,
        formData.utmterm,
        formData.utmcontent,
        formData.inpagebookmark,
    ).toLowerCase())
  }
}
 
 // Adding more URL input fields
 var activeInputFieldsCounter = 1; // This is used to make sure there are not more than 10 url fields showing at any time
 var inputFieldsLimit = 10;
 var totalInputFieldsCounter = 1; // This only grows and is used for unique IDs
 
 window.addUrlInputField= (divId) => {
     if (activeInputFieldsCounter >= inputFieldsLimit) {
         // Disable ability to add more url's after it reaches limit
         document.getElementById("add-url-button").disabled = true;
     } else {
        activeInputFieldsCounter++;
        totalInputFieldsCounter++;
         var newdiv = document.createElement("div");
         newdiv.classList.add('url-container')
         newdiv.id = 'url-container-'+totalInputFieldsCounter;
         newdiv.innerHTML = '<br>' +
         '<input '+
          'name="web-page-url"'+
          'type="text"'+ 
          'placeholder=""'+
          'class="form-control input-md extra-web-page-url"'+
          'onblur="validateInputField(this)"'+ 
          'data-is-abc-url="true"'+
          'data-no-spaces="true"'+
          'data-validate-on-submit="true"'+
          'data-url-input="true"'+
          'data-readonly-on-next="true"'+
          '/>'+
          '<button class="remove-url-button" onClick="removeUrlField('+totalInputFieldsCounter+')">remove</button>';
         document
             .getElementById(divId)
             .appendChild(newdiv);
     }
 }

 window.removeUrlField = (index) => {
   document.getElementById('url-container-'+index).remove();
   activeInputFieldsCounter--;
 }

 function addUTMUrlFields(webUrlArray) {
   // Check for any output fields already exist and remove them.
  var UTMOutputFields = document.querySelectorAll('[data-UTM-output]');

  UTMOutputFields.forEach(function (UTMField) {
    UTMField.parentElement.remove();
  })


  for (var i = 0; i < webUrlArray.length; i++){
    
    var newdiv = document.createElement("div");
    newdiv.setAttribute("id", "input-group");
    newdiv.setAttribute("class", "input-group");

    var newId = "campaign-tag-utm-"+i.toString()

    newdiv.innerHTML = 
    '<input id="'+newId+'" type="text" '+
      'class="form-control" '+
      'placeholder="You must first define your campaign" '+
      'readonly="true" '+
      'data-UTM-output '+
      'data-disable-to-validate="true"'+
    '/>'+
    '<span class="input-group-btn"> '+
      '<button '+
        'class="btn btn-default" '+
        'type="button" '+
        'data-clipboard-target="#'+newId+'" '+
        'onclick="copyText('+"'"+newId+"'"+')"'+
      '>'+
        'Copy URL!'+
    ' </button> '+
    '</span>';
    var parentDiv = document
        .getElementById("utm-output-container")

    if(i>0){

      newdiv.style.paddingTop="10px";
    }

    parentDiv.appendChild(newdiv)
  }
}


function getFormData() {

  var formData = {
    campaignowner: document.getElementById("campaign-owner-select").value.trim(),
    marketingunit: document.getElementById("marketing-unit-select").value.trim(),
    marketingsubunit: document.getElementById("marketing-sub-unit-select").value.trim(),
    brand: document.getElementById("brand-service-select").value.trim(),
    agencyrefid: document.getElementById("reference-id").value.trim(),
    inpagebookmark: document.getElementById("page-bookmark").value.trim(),
    source: document.getElementById("source-select").value.trim(),
    medium: document.getElementById("medium-select").value.trim(),
    utmterm: document.getElementById("campaign-term").value.trim(),
    utmcontent: document.getElementById("campaign-content").value.trim(),
  }

  return formData;
}


// string each UTM parameter together into one URL
function getCampaignCodeUTM(
  url,
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term,
  utm_content,
  inpagebookmark
) {
  var uri = url;

  var queryParameterSeparator = "";

  // the query parameter separator depends on whether the URL already has a query parameter
  if (URLHasQueryParameters(url)) {
    queryParameterSeparator = "&";
  } else {
    queryParameterSeparator = "?";
  }

  uri +=
    queryParameterSeparator +
    "utm_source=" +
    encodeURIComponent(utm_source) +
    "&utm_medium=" +
    encodeURIComponent(utm_medium);
  uri += "&utm_campaign=" + encodeURIComponent(utm_campaign);

  if (utm_term !== undefined && utm_term !== "") {
    uri += "&utm_term=" + encodeURIComponent(utm_term);
  }

  if (utm_content !== undefined && utm_content !== "") {
    uri += "&utm_content=" + encodeURIComponent(utm_content);
  }

  if (inpagebookmark !== undefined && inpagebookmark !== ""){
    uri += "#" + inpagebookmark;
  }

  return uri;
}

// construct the campaignname using the format expected by the ABC Mailcentre
function getCampaignCodified(campaignowner,marketingunit, marketingsubunit, brand, agencyrefid) {  
  var ownerAgencyIDsCombined = combineOwnerAgencyID(campaignowner, agencyrefid);
  
  var templateData = {
    marketingunit_fieldname: "mu",
    marketingunit_value: marketingunit,
  
    marketingsubunit_fieldname: "msu",
    marketingsubunit_value: marketingsubunit,
  
    brand_fieldname: "bd",
    brand_value:brand,
  
    agencyid_fieldname: "aid",
    agencyid_value: ownerAgencyIDsCombined
  };
  
  // Compile the UTM data into the correct format
  // {{marketingunit_fieldname}}~{{marketingunit_value}}|{{marketingsubunit_fieldname}}~{{marketingsubunit_value}}|{{brand_fieldname}}~{{brand_value}}|{{agencyid_fieldname}}~{{agencyid_value}}
  var campaignCodified = 
    templateData.marketingunit_fieldname+"~"+templateData.marketingunit_value+"|"+
    templateData.marketingsubunit_fieldname+"~"+templateData.marketingsubunit_value+"|"+
    templateData.brand_fieldname+"~"+templateData.brand_value+"|"+
    templateData.agencyid_fieldname+"~"+templateData.agencyid_value;
  
  return campaignCodified;
}


function combineOwnerAgencyID(campaignowner, agencyrefid) {
  var separator = ":";

  if (agencyrefid == null) {
    return campaignowner;
  } else {
    return campaignowner + separator + agencyrefid;
  }
}

// returns true if string contains '?', false otherwises
function URLHasQueryParameters(url) {
  var regex = /\?/i;

  var match = url.match(regex);
  //  console.log(match)

  if (match !== null) {
    return true;
  } else {
    return false;
  }
}

// Makes all form fields disabled and revents further changes. Shows generage code button which moves on to next step, and back which returns form to editable state.
function changeFormToReadonly () {
  var formElementsToValidate = document.querySelectorAll('[data-readonly-on-next]');

  // Disable all fields, and remove empty URL fields.
  formElementsToValidate.forEach(function (formField) {
    if(formField.getAttribute('data-url-input') && (formField.value === "" || formField.value === undefined)){
      formField.parentElement.remove();
      activeInputFieldsCounter--;
    }
    formField.disabled = true;
  })

  var helpTextFields = document.querySelectorAll('[data-validation-help-text]');

  helpTextFields.forEach(function (helpText) {
    helpText.hidden = true;
  })
}

// Makes all form fields editable again
window.changeFormToEditable = () => {
  var elementsToDisable = document.querySelectorAll('[data-readonly-on-next]');

  elementsToDisable.forEach(function (formField) {
    formField.disabled = false;
  })


  var helpTextFields = document.querySelectorAll('[data-validation-help-text]');

  helpTextFields.forEach(function (helpText) {
    helpText.hidden = false;
  })




  // Change buttons to Next and show add url button again. Change header from step 1 to step 2
  document.getElementById('next-button-container').hidden = false; 
  document.getElementById('header-step-1').hidden = false;
  document.getElementById('add-url-button').style.display = "block";

  document.getElementById('back-button-container').hidden = true;
  document.getElementById('generate-code-button-container').hidden = true;
  document.getElementById('header-step-2').hidden = true;

  document.getElementById('home-title').scrollIntoView();
  //$('html,body').scrollTop(0);
}

// Opens form to step 1, if resetValues is true the inputs will be reset.
window.OpenFirstStep = () => {
  document.getElementById('reset-button').hidden = false;
  document.getElementById('main-form-body').hidden = false;
  document.getElementById('campaign-code-body').hidden = true;
  document.getElementById('header-step-3').hidden = true;

  changeFormToEditable();
}

// Opens form to step 2, keeps values from step 1.
window.OpenSecondStep = () => {
  // Can only move onto next step if form is valid
  if(!validateForm()){
    return false;
  }

  changeFormToReadonly()
  
  document.getElementById('reset-button').hidden = false;

  document.getElementById('main-form-body').hidden = false;
  document.getElementById('campaign-code-body').hidden = true;
  document.getElementById('header-step-3').hidden = true;

  // Change buttons to Back and Generate code and hide add url button. Change header from step 1 to step 2
  document.getElementById('next-button-container').hidden = true; 
  document.getElementById('header-step-1').hidden = true;
  document.getElementById('add-url-button').style.display = "none";

  document.getElementById('back-button-container').hidden = false;
  document.getElementById('generate-code-button-container').hidden = false;
  document.getElementById('header-step-2').hidden = false;

  document.getElementById('home-title').scrollIntoView();
  //$('html,body').scrollTop(0);
}

// Opens form to step 3.
window.OpenThirdStep = () => {

  generateCampaignCode();

  document.getElementById('reset-button').hidden = true;

  // Hide form, show campaign code section.
  document.getElementById('main-form-body').hidden = true;
  document.getElementById('campaign-code-body').hidden = false;

  document.getElementById('header-step-2').hidden = true;
  document.getElementById('header-step-3').hidden = false;
}

window.ResetForm = () => {
  if(window.confirm("Are you sure you want to reset the form? This will clear all fields.")){
    document.getElementById('campaign-code-form').reset();
    var extraUrlInputs = document.querySelectorAll('.extra-web-page-url');
    extraUrlInputs.forEach(function(input) {
      input.remove();
    })
    activeInputFieldsCounter = 1;
  
    document.getElementById("add-url-button").disabled = false;

    // Reset marketing sub unit to be unselected and hidden
    document.getElementById("marketing-sub-unit-select").selectedIndex = 0; // 0 is the -- select an option -- value, set to -1 if you want nothing selected
    document.getElementById("marketing-sub-unit-container").hidden = true;
  }
}


window.RestartForm = () => {
    if(window.confirm("Are you sure you want to reset the form? This will clear all fields.")){
    OpenFirstStep();
    document.getElementById('campaign-code-form').reset();
    var extraUrlInputs = document.querySelectorAll('.extra-web-page-url');
    extraUrlInputs.forEach(function(input) {
      input.remove();
    })
    activeInputFieldsCounter = 1;
  
    document.getElementById("add-url-button").disabled = false;

    // Reset marketing sub unit to be unselected and hidden
    document.getElementById("marketing-sub-unit-select").selectedIndex = 0; // 0 is the -- select an option -- value, set to -1 if you want nothing selected
    document.getElementById("marketing-sub-unit-container").hidden = true;
  }
}